<!--
	Obrazovka prestávky
-->
<script lang="ts">
	import secondsToTime from "../libs/time/format";
	import { DialerAgentStatus } from "../libs/app/dialer-agent-enums";
	import { confirmation } from "../components/Confirmation";
	import { api, dialerAgent } from "../bootstrap";
	import { navigate } from "svelte-navigator";
	import { onDestroy, onMount } from "svelte";

	let startDateTime = Date.now();
	let formattedDuration = "00:00:00";

	let interval = null;

	/**
	 * Začatie prestávky
	 * odpojenie liniek a spustenie odpočtu
	 */
	function start() {
		dialerAgent.target = null;
		dialerAgent.status.set(DialerAgentStatus.Break);

		interval = setInterval(() => {
			const now = Date.now();
			const duration = Math.round((now - startDateTime) / 1000);
			formattedDuration = secondsToTime(duration)
		}, 1000);

		api.pause();
	}

	/**
	 * Ukončenie prestávky
	 */
	async function end() {
		const result = await confirmation.show("Naozaj chcete ukončiť prestávku?");

		if (result === false) {
			return false;
		}

		navigate("/main/summary");
	}

	/**
	 * Zahájenie prestávky
	 */
	onMount(start);

	/**
	 * Ukončenie odpočtu a znovupripojenie liniek
	 */
	onDestroy(() => {
		clearInterval(interval);
		interval = null;

		api.unpause();
	});
</script>

<svelte:head>
	<title>Prestávka | DialerAgent</title>
</svelte:head>

<div class="container">
	<div class="alert alert-dark mt-3">
		<p class="h2">Prestávka</p>

		<p>Trvanie: {formattedDuration}</p>

		<button class="btn btn-success" on:click={end}>Koniec prestávky</button>
	</div>
</div>
